import { Component, OnInit } from '@angular/core';
import { AuthenticateserviceService } from 'src/app/_service/authenticateservice.service';

@Component({
  selector: 'app-white-label-invalid',
  templateUrl: './white-label-invalid.component.html',
  styleUrls: ['./white-label-invalid.component.css']
})
export class WhiteLabelInvalidComponent implements OnInit {

  get isLoggedIn() {
    return !!localStorage.getItem('token');
  }

  constructor(private auth: AuthenticateserviceService) {}

  ngOnInit(): void {
    
  }

  logout() {
    this.auth.logout();
  }
}
